module.exports = __webpack_public_path__ + "insa-report/web/locale/hr/viewer.properties";


//////////////////
// WEBPACK FOOTER
// ./app/insa-report/web/locale/hr/viewer.properties
// module id = 965
// module chunks = 3